import { AxiosError } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { CorporateHealthClaim } from '@models/CorporateHealthClaim';
import { CorporateHealthClaimApi } from '@apis/CorporateHealthClaimApi';
import { CorporateHealthOrderApi } from '@apis/CorporateHealthOrderApi';
import { CorporateHealthOrder } from '@models/CorporateHealthOrder';
import { SagaPayload } from '@utils/typescript';
import { history } from '@utils/history';
import { getResponseError } from '@utils/error';

import { isArray, mapValues } from 'lodash';

import {
  policyFetch,
  PolicyFetchPayload,
  userFetch,
  UserFetchPayload,
  corporateHealthOrderUserRemainingBenefitsFetch,
  CorporateHealthOrderUserRemainingBenefitsFetchPayload,
  corporateHealthClaimCreate,
  CorporateHealthClaimCreatePayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';
import { CorporateUser } from '@models/User';
import { CorporateHealthOrderUserRemainingBenefit } from '@models/CorporateHealthOrderUserRemainingBenefit';

function* handlePolicyFetch({ payload }: SagaPayload<PolicyFetchPayload>) {
  const state: StateUpdatePayload = { policy: null };
  try {
    state.policy = (yield call(CorporateHealthOrderApi.findByUsername, payload)) as CorporateHealthOrder;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleUserFetch({ payload }: SagaPayload<UserFetchPayload>) {
  const state: StateUpdatePayload = { user: null };
  try {
    state.user = (yield call(CorporateHealthOrderApi.findUserByUsername, payload)) as CorporateUser;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleCorporateHealthClaimCreate({ payload }: SagaPayload<CorporateHealthClaimCreatePayload>) {
  try {
    const state: StateUpdatePayload = { corporateHealthClaim: null };
    state.corporateHealthClaim = (yield call(CorporateHealthClaimApi.create, payload)) as CorporateHealthClaim;
    yield put(stateUpdate(state));
    history.navigate(`/user-dashboard/claim/CorporateHealthClaim/${state.corporateHealthClaim.id}`, {
      replace: true,
    });
  } catch (e) {
    const state: StateUpdatePayload = {};
    state.errors = mapValues(getResponseError(e as AxiosError).errors, (messages, _field) => {
      if (isArray(messages)) return (messages as string[]).join(', ');
      return messages;
    });

    yield put(stateUpdate(state));
  }
}

function* handleCorporateHealthOrderUserRemainingBenefitsFetch({ payload }: SagaPayload<CorporateHealthOrderUserRemainingBenefitsFetchPayload>) {
  const state: StateUpdatePayload = {};
  try {
    state.corporateHealthOrderUserRemainingBenefits = (yield call(CorporateHealthOrderApi.getCorporateHealthOrderUserRemainingBenefits, payload)) as CorporateHealthOrderUserRemainingBenefit[];
    yield put(stateUpdate(state));
  } catch { }
}

export default function* () {
  yield takeLatest(policyFetch, handlePolicyFetch);
  yield takeLatest(userFetch, handleUserFetch);
  yield takeLatest(corporateHealthOrderUserRemainingBenefitsFetch, handleCorporateHealthOrderUserRemainingBenefitsFetch);
  yield takeLatest(corporateHealthClaimCreate, handleCorporateHealthClaimCreate);
}
